<template lang="pug">
.mg-game__new-card(:class="getBackgroundClass")
  .mg-card
    .mg-card__inner
      img.mg-card__front(:src="getImgSrc(getCardName)")
      img.mg-card__back(:src="getImgSrc('back')")

  .mg-game__loader(v-show="show_loader")
</template>

<script>
import getStoreModuleByName from "@mrg_minigames/common/helpers/store/getStoreModuleByName";
import { createNamespacedHelpers } from "vuex";
const mg_global = getStoreModuleByName("global");
const { mapState } = createNamespacedHelpers(mg_global);

export default {
  name: "NewCard",

  data() {
    return {
      show_loader: true,
    };
  },

  computed: {
    ...mapState(["new_card"]),

    getCardName() {
      if (!this.new_card) return "back";

      let amount = this.new_card.amount > 5 ? 1 : this.new_card.amount;
      return `card_row${this.new_card.level}_${amount}`;
    },
    getBackgroundClass() {
      return !this.new_card
        ? "mg-game__new-card--back"
        : `mg-game__new-card--${this.new_card.level} animate`;
    },
  },

  mounted() {
    if (this.new_card) {
      this.show_loader = false;
      setTimeout(this.closePopup, 2500);
    } else {
      this.drawCard();
    }
  },

  beforeDestroy() {
    this.$emit("stopProgress");
    this.$store.commit(`${mg_global}/placeNewCard`, this.new_card);
    this.$store.commit(`${mg_global}/setNewCard`, null);
  },

  methods: {
    closePopup() {
      this.$emit("closePopup");
    },

    getImgSrc(img) {
      try {
        return require(`@/assets/game/images/cards/${img}.png`);
      } catch (e) {
        return require(`@/assets/game/images/cards/back.png`);
      }
    },

    drawCard() {
      this.$store
        .dispatch(`${mg_global}/drawCard`)
        .then(() => {
          this.show_loader = false;
        })
        .then(() => {
          setTimeout(this.closePopup, 2500);
        })
        .catch((error) => {
          this.closePopup();

          this.$notify({
            type: "error",
            closeOnClick: "true",
            duration: 5000,
            group: "collection",
            position: "bottom right",
            text: this.$t(`error.${error.message}`),
          });
        });
    },
  },
};
</script>
